import { DialogTitle } from '@headlessui/react';
import PropTypes from 'prop-types';
import Modal from '../../../shared/Modal/Modal';
import AccountCreditCardModalWrapper from './AccountCreditCardModalWrapper';

function AccountCreditCardModal({
  open,
  handleCloseModal,
  accountId,
  title = 'New credit card',
  hideDefaultCardCheckbox = false,
}) {
  return (
    <Modal open={open} setOpen={handleCloseModal} size="2xl" zdex={999}>
      <div>
        <div className="text-center">
          <DialogTitle
            as="h2"
            className="font-semibold text-2xl text-rcgray-900 capitalize leading-6"
          >
            {title}
          </DialogTitle>
        </div>
      </div>
      <div className="mt-4">
        <AccountCreditCardModalWrapper
          accountId={accountId}
          handleCloseModal={handleCloseModal}
          hideDefaultCardCheckbox={hideDefaultCardCheckbox}
        />
      </div>
    </Modal>
  );
}

AccountCreditCardModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleCloseModal: PropTypes.func.isRequired,
  accountId: PropTypes.string.isRequired,
  title: PropTypes.string,
  hideDefaultCardCheckbox: PropTypes.bool,
};

export default AccountCreditCardModal;
